<template>
  <transition name="tag-user">
    <div
      v-if="filteredUsersTag.length"
      class="tag-user__container"
      :data-qa="dataQa">
      <TagUserItem
        v-for="(item, index) in filteredUsersTag"
        :key="`tag-item-${index}`"
        :active="index === activeItem"
        :data-qa="`${dataQa}-contactId`"
        :value="item"
        @mouseover="activeItem = index"
        @select="val => setUserTag(item)"/>
    </div>
  </transition>
</template>

<script>
import TagUserItem from 'components/common/blocks/inner-chat/TagUserItem.vue'

export default {
  name: 'tagUser',
  props: {
    filteredUsersTag: {
      type: Array,
      required: true
    },
    selectItem: {
      type: Boolean,
      default: null
    },
    activeUpOrDown: {
      type: Number,
      default: null
    },
    dataQa: {
      type: String,
      default: 'tag-user'
    }
  },
  data() {
    return {
      activeItem: 0
    }
  },
  methods: {
    setUserTag(item) {
      this.$emit('select-user-tag', item)
      this.$nextTick(() => {
        this.$emit('update:filteredUsersTag', [])
      })
    }
  },
  watch: {
    filteredUsersTag(val, oldVal) {
      if (!oldVal.length || val.length !== oldVal.length) {
        this.activeItem = 0
      }
    },
    selectItem(val) {
      if (val) {
        this.setUserTag(this.filteredUsersTag[this.activeItem])
      }
    },
    activeUpOrDown() {
      if (
        this.activeUpOrDown > 0 &&
				this.activeItem < this.filteredUsersTag.length - 1
      ) {
        this.activeItem++
      } else if (this.activeUpOrDown < 0 && this.activeItem > 0) {
        this.activeItem--
      }
      const activeITem = document.getElementsByClassName('people-tag active')
      if (activeITem?.length) {
        activeITem[0].scrollIntoView({block: 'center', behavior: 'smooth'})
      }
      this.$emit('activate-item')
    }
  },
  components: {
    TagUserItem
  }
}
</script>
<style scoped lang="scss">
.tag-user__container {
  padding: 2px 0;
  width: 345px;
  height: 228px;
  overflow: auto;
  bottom: 86px;
  right: 20px;
  background: var(--v-main__light_green-base);
  border-radius: 5px;
  z-index: 2;
  border: 2px solid var(--color-main-green);
}
</style>
